import { t } from 'i18next';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export const TOAST_TIME_OUT = 3000;

const WRITE_LOCKED_TOAST_ID = 'write-locked';
const WRITE_LOCKED_TOAST_TIME_OUT = 8000;

// A refused request rejects through a pure promise chain, so the form's own catch (and its
// generic "unknown error" toast) runs in the same microtask flush as the write-lock notice.
// Suppressing error toasts only until the next event-loop task drops that duplicate without
// swallowing an unrelated failure that happens a moment later.
let suppressErrorToasts = false;

const showToast = (message: string, type: 'success' | 'error' | 'warn' | 'info', params: object): void => {
  toast[type](message, {
    position: 'top-right',
    autoClose: TOAST_TIME_OUT,
    ...params,
  });
};

export const showSuccessToast = (message: string, params: object = {}): void => showToast(message, 'success', params);
export const showErrorToast = (message: string, params: object = {}): void => {
  if (suppressErrorToasts) {
    return;
  }

  showToast(message, 'error', params);
};
export const showWarningToast = (message: string, params: object = {}): void => showToast(message, 'warn', params);
export const showInfoToast = (message: string, params: object = {}): void => showToast(message, 'info', params);

export const showWriteLockedToast = (): void => {
  suppressErrorToasts = true;
  setTimeout((): void => {
    suppressErrorToasts = false;
  }, 0);

  // A fixed toastId collapses several refused requests in a row into a single notice.
  showWarningToast(t('errors.writeLocked.message'), {
    toastId: WRITE_LOCKED_TOAST_ID,
    autoClose: WRITE_LOCKED_TOAST_TIME_OUT,
  });
};
